export const productCreateConfig = (createSelectOptions) => {
  return [
    {
      step_title: 'Define',
      form_title: 'Define Product',
      section: [
        {
          name: 'name',
          input: 'input',
          type: 'text',
          placeholder: 'Enter Name',
          rules: [
            {
              required: true,
              message: 'Product name is required',
            },
          ],
        },
        {
          name: 'short_name',
          input: 'input',
          type: 'text',
          placeholder: 'Enter Short Name',
          maxLength: 10,
          rules: [
            {
              required: true,
              message: 'Short name is required, 10 character max',
            },
          ],
        },
        {
          name: 'group',
          input: 'select',
          type: 'single',
          placeholder: 'Select Type',
          options: createSelectOptions.groups,
          rules: [
            {
              required: true,
              message: 'Product group is required',
            },
          ],
        },
      ],
    },
    {
      step_title: 'Details',
      form_title: 'Product Details',
      section: [
        {
          name: 'weight_group',
          input: 'input',
          type: 'text',
          placeholder: 'Enter Weight Group',
        },
        {
          name: 'specific_gravity',
          input: 'inputNumber',
          min: -90,
          max: 90,
          precision: 4,
          placeholder: 'Enter Specific Gravity',
        },
        // {
        //   name: 'icon',
        //   input: 'input',
        //   type: 'text',
        //   placeholder: 'Enter Product Icon',
        // },
      ],
    },
  ]
}
